// Local app contexts — ported from eb-ui creator-collections-listing
// `src/context.ts` (webpack-era, identical shape).
//
//   ApplicationContext  = the WHOLE reconstructed __SERVER_DATA__ (CollectionServerData
//                         | CollectionMovedServerData). Carried so the deep leaves
//                         (CollectionHero, CollectionDetails, CardsCarousel share_props,
//                         PageLayoutPreview) read the same object eb-ui's context did.
//   AnalyticsContext    = { collectionId, organizerId } — the GA-dimension pair
//                         every trackEvent call needs. (site-analytics is a GA ghost —
//                         see _shared/analytics.ts — but the KEYS still flow through.)
import React from 'react';

import type { ServerData } from '@/types';

export const ApplicationContext = React.createContext<ServerData | null>(null);

interface AnalyticsContextValue {
    collectionId: string;
    organizerId: string;
}

export const AnalyticsContext = React.createContext<AnalyticsContextValue>({
    collectionId: '',
    organizerId: '',
});
